import api from '@/helpers/api'

const API_READ=`/api/tier/detail/`

export default {
  namespaced:true,
  state: {
    status: '',
    ShowMemberTier:[],
    meta:{
      page:1,
      limit:10,
      total:1
    },
    filter: {}
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { ShowMemberTier }) {
      state.ShowMemberTier = [...ShowMemberTier]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    reset_meta(state) {
        state.meta = {
            limit: 10,
            page: 1,
            total: 1,
        }
    }
  },
  actions: {
    read({commit, state}){
        commit('request');
        const {meta} = state
        const {filter} = state
        const {search} = state

        return new Promise((resolve, reject) => {
            api.request('get', `${API_READ}${state.filter.tier_id}`, {meta, filter, search})
            .then((result) => {
              const data = result.data.data;
              if (Array.isArray(data.data_res)) {
                  commit('read', { ShowMemberTier: data.data_res });
              } else {
                  commit('error', { message: 'Invalid data format' });
                  return reject(new Error('Invalid data format'));
              }

              commit('switch_page', { meta: { ...data.meta } });
              commit('success');
              return resolve(data.data_res);
            }).catch((err) => {
                commit('error', {message: err})
                return reject(err);
            });
        });
    },
  },
  getters : {
    ShowMemberTier: ()=>state => state.ShowMemberTier,
  }
}